import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "word-list__word-container" }
const _hoisted_2 = { class: "word-list__word-heading" }
const _hoisted_3 = { class: "word-list__word-flags" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "word-list__word-block" }
const _hoisted_7 = {
  key: 1,
  class: "word-list__word-block-type"
}
const _hoisted_8 = {
  key: 3,
  class: "word-list__word-block-gender"
}
const _hoisted_9 = { class: "add-to-wordbook" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", {
          class: _normalizeClass(["word-list__word-text", {'text-capitalize': _ctx.word.type=='noun'}])
        }, _toDisplayString(_ctx.word.type === 'noun' ?
              _ctx.nounArticle(_ctx.word.textLanguage, _ctx.word.gender) : '') + " " + _toDisplayString(_ctx.word.text), 3),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.CanSpeak)
            ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                key: 0,
                icon: _ctx.faVolumeHigh,
                class: "word-list__word-speaker",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.speak(_ctx.word.text, _ctx.word.textLanguage)), ["stop"]))
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: _ctx.imageURL(_ctx.flags[_ctx.word.textLanguage]),
            alt: "",
            class: "word-list__word-flags-text"
          }, null, 8, _hoisted_4),
          _createElementVNode("img", {
            src: _ctx.imageURL(_ctx.flags[_ctx.word.meaningLanguage]),
            alt: "",
            class: "word-list__word-flags-meaning"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", {
          class: _normalizeClass(["word-list__word-block-meaning", {'text-capitalize': _ctx.word.type=='noun'}])
        }, _toDisplayString(_ctx.word.meaning), 3),
        (_ctx.word.type)
          ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
              key: 0,
              class: "word-list__word-block-dot",
              icon: _ctx.faCircleDot
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        (_ctx.word.type)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.t(_ctx.word.type)), 1))
          : _createCommentVNode("", true),
        (_ctx.word.gender)
          ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
              key: 2,
              class: "word-list__word-block-dot",
              icon: _ctx.genderIcon(_ctx.word.gender)
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        (_ctx.word.gender)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.t(_ctx.gendersData[_ctx.word.gender])), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_FontAwesomeIcon, {
        icon: _ctx.word.selected ? _ctx.faHeart : _ctx.faOutlineHeart
      }, null, 8, ["icon"])
    ])
  ]))
}